// extracted by mini-css-extract-plugin
export default {"table-cell":"TableSkeleton_table-cell__wiubl","tr":"TableSkeleton_tr__zWxhZ","table-row":"TableSkeleton_table-row__Cn5Nm"};